import { Buttons } from "../../../generic-sprites/Buttons"
import { Sprites } from "../../../utils/Sprites"
import { TmAudio, TmSprite } from "../TimeMachineAssets"

const flash = "flash"

export class ArrowButton {
    button: Phaser.Sprite
    forwardSound: Phaser.Sound

    constructor(game: Phaser.Game, x: number, y: number, group?: Phaser.Group, invert = false) {
        this.button = Sprites.add(game, TmSprite.ARROW, {x, y, group})
        this.button.animations.add(flash, [1, 2], 6)
        this.forwardSound = game.add.audio(TmAudio.FORWARD_BEEP)
        this.forwardSound.volume = 0.7
        if (invert) {
            this.button.scale.x *= -1
        }
    }


    addOnClick = (onClick: () => void) => {
        Buttons.makeSpriteButton(this.button, () => {
            onClick()
        })
    }

    disable = () => {
        this.button.animations.stop()
        this.inactive()
        Buttons.undoSpriteButton(this.button)
    }

    beep = () => this.forwardSound.play()

    flash = () => this.button.animations.play(flash, undefined, true)

    active = () => this.button.frame = 1

    inactive = () => this.button.frame = 0
}
